import { useState, useEffect, useRef, useCallback } from "react";
import trustLogo from "./assets/trust_logo.png";
import AnnouncementsBanner from "./AnnouncementsBanner";
import img1 from "./assets/IMG_0289.JPG";
import img2 from "./assets/IMG_0307.JPG";
import img3 from "./assets/IMG_0308.JPG";
import img4 from "./assets/IMG_0316.JPG";
import img5 from "./assets/IMG_9096.JPG";
import img6 from "./assets/IMG_9601.JPG";
import img7 from "./assets/IMG_9602.JPG";
import EventPopup from "./EventPopup";
import Campaigns from "./pages/Campaigns";
import CampaignPopup from "./pages/CampaignPopup";
import VolunteerRegistrationModal from "./pages/VolunteerRegistrationModal";
import RazorpayButton from "./components/RazorpayButton";
import { Link } from "react-router-dom";
import {
  Heart, School, Leaf, Users, Phone, Mail, MapPin, ChevronLeft,
  ChevronRight, Menu, X, Award, BookOpen, Recycle,
  ShieldCheck, Star, Sprout, Utensils, Shirt, Pencil,
  Globe, ArrowRight,
  CreditCard, Banknote, AlertTriangle, CheckCircle,
  ZoomIn, ChevronDown, ArrowUpRight,
  Target, TrendingUp, Handshake, Medal, Repeat, GraduationCap
} from "lucide-react";
// ─── Favicon ───
const setFavicon = () => {
  const link = document.querySelector("link[rel~='icon']") || document.createElement("link");
  link.type = "image/png"; link.rel = "shortcut icon"; link.href = trustLogo;
  document.head.appendChild(link);
  document.title = "Help Them Shine Trust";
};

const TABS = ["Home","About Us","Join Us","Contact Us","Donate","Certifications","Gallery"];


const HOME_IMAGES = [img1, img2, img3, img4, img5, img6, img7];

const GALLERY_CATS = [
  { key:"acadmic", label:"Academic", emoji:"🎓", color:"#3b82f6", light:"#eff6ff", count:106, prefix:"a" },
  { key:"festival", label:"Festivals", emoji:"🎉", color:"#ec4899", light:"#fdf2f8", count:60, prefix:"fes" },
  { key:"food", label:"Food Drive", emoji:"🍱", color:"#f97316", light:"#fff7ed", count:63, prefix:"food" },
  { key:"hygine", label:"Hygiene", emoji:"🌸", color:"#a855f7", light:"#faf5ff", count:30, prefix:"h" },
  { key:"plant", label:"Plantation", emoji:"🌱", color:"#22c55e", light:"#f0fdf4", count:18, prefix:"plant" },
];

function genImages(cat, count) {
  return Array.from({length:count},(_,i)=>
    `https://ik.imagekit.io/htst/images/${cat.key}/${cat.prefix}${i+1}.jpg?updatedAt=1745299298051`
  );
}

const CERTS = [
  { path:"https://ik.imagekit.io/htst/images/documents/2.jpg?updatedAt=1745299245405", title:"NITI Aayog Certification", by:"NITI Aayog, Govt. of India", year:"2020" },
  { path:"https://ik.imagekit.io/htst/images/documents/3.jpg?updatedAt=1745299245405", title:"UDYAM Registration", by:"Ministry of MSME", year:"2020" },
  { path:"https://ik.imagekit.io/htst/images/documents/4.jpg?updatedAt=1745299245405", title:"MCA Registration", by:"Ministry of Corporate Affairs", year:"2021" },
  { path:"https://ik.imagekit.io/htst/images/documents/6.jpg?updatedAt=1745299245405", title:"Human Rights Certification", by:"Human Rights Commission, India", year:"2020" },
  { path:"https://ik.imagekit.io/htst/images/documents/7.jpg?updatedAt=1745299245405", title:"Women Empowerment Accreditation", by:"National Commission for Women", year:"2020" },
  { path:"https://ik.imagekit.io/htst/images/documents/8.jpg?updatedAt=1745299245405", title:"Sports Authority Certification", by:"Ministry of Youth Affairs & Sports", year:"2020" },
  { path:"https://ik.imagekit.io/htst/images/documents/9.jpg?updatedAt=1745299245405", title:"Child Welfare Accreditation", by:"Ministry of Women & Child Development", year:"2020" },
  { path:"https://ik.imagekit.io/htst/images/documents/10.jpg?updatedAt=1745299245405", title:"Disability Inclusion Certificate", by:"Delhi Wheelchair Cricket Association", year:"2022" },
  { path:"https://ik.imagekit.io/htst/images/documents/11.jpg?updatedAt=1745299245405", title:"Humanitarian Trust Registration", by:"HUM Manavtavadi Log Trust", year:"2021" },
];

// ─── Animated Counter ───
function useCounter(target, duration=2200) {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);
  useEffect(()=>{
    const obs = new IntersectionObserver(([e])=>{
      if(e.isIntersecting && !started.current){
        started.current=true;
        const start=performance.now();
        const ease=(t)=>t<0.5?2*t*t:1-Math.pow(-2*t+2,2)/2;
        const tick=(now)=>{
          const p=Math.min((now-start)/duration,1);
          setVal(Math.floor(ease(p)*target));
          if(p<1) requestAnimationFrame(tick); else setVal(target);
        };
        requestAnimationFrame(tick);
      }
    },{threshold:0.3});
    if(ref.current) obs.observe(ref.current);
    return()=>obs.disconnect();
  },[target,duration]);
  return [val,ref];
}

// ─── Stat Pill ───
function StatPill({icon:Icon, label, value, suffix="", color="#f59e0b"}) {
  const num = parseInt(value.replace(/[^0-9]/g,""));
  const [count,ref] = useCounter(num);
  const display = value.includes("k") ? `${(count/1000).toFixed(count>=1000?0:1)}k` : `${count}`;
  return (
    <div ref={ref} className="stat-pill">
      <div className="stat-pill-icon" style={{background:`${color}22`,border:`1px solid ${color}44`}}>
        <Icon size={20} color={color}/>
      </div>
      <div>
        <div className="stat-num" style={{color}}>{display}{suffix}</div>
        <div className="stat-lbl">{label}</div>
      </div>
    </div>
  );
}

// ─── Hero Carousel ───
function HeroCarousel({goTo}) {
  const [idx,setIdx]=useState(0);
  const timer=useRef(null);
  const reset=useCallback(()=>{
    clearInterval(timer.current);
    timer.current=setInterval(()=>setIdx(i=>(i+1)%HOME_IMAGES.length),4500);
  },[]);
  useEffect(()=>{reset();return()=>clearInterval(timer.current);},[reset]);
  const go=(d)=>{setIdx(i=>(i+d+HOME_IMAGES.length)%HOME_IMAGES.length);reset();};
  return (
    <div className="hero-wrap">
      {HOME_IMAGES.map((src,i)=>(
        <div key={i} className="hero-slide" style={{opacity:i===idx?1:0,zIndex:i===idx?1:0}}>
          <img src={src} alt="" className="hero-img" onError={e=>e.target.style.display="none"}/>
          <div className="hero-vignette"/>
        </div>
      ))}
      {/* Content */}
      <div className="hero-content">
        <div className="hero-badge">
          <span className="hero-badge-dot"/>
          Transforming Lives Since 2020
        </div>
        <h1 className="hero-title">
          <span className="hero-title-line">Help Them</span>
          <span className="hero-title-accent">Shine.</span>
        </h1>
        <p className="hero-sub">Empowering communities through education, healthcare &amp; sustainable development across India.</p>
        <div className="hero-btns">
          <button onClick={()=>goTo(4)} className="nav-donate-btn">
  <Heart size={14} fill="currentColor"/> Donate
</button>
         <button onClick={()=>goTo(2)} className="btn-ghost">
            Join the Movement <ArrowRight size={16}/>
          </button>
        </div>
        <div className="hero-micro-stats">
          {[["978","Children"],["68k+","Pads Distributed"],["34k+","Trees Planted"]].map(([n,l])=>(
            <div key={l} className="hero-micro">
              <span className="hero-micro-num">{n}</span>
              <span className="hero-micro-lbl">{l}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Controls */}
      <button onClick={()=>go(-1)} className="hero-arrow hero-arrow-l"><ChevronLeft size={20}/></button>
      <button onClick={()=>go(1)} className="hero-arrow hero-arrow-r"><ChevronRight size={20}/></button>
      <div className="hero-dots">
        {HOME_IMAGES.map((_,i)=>(
          <button key={i} onClick={()=>{setIdx(i);reset();}} className={`hero-dot${i===idx?" active":""}`}/>
        ))}
      </div>
      {/* Slide counter */}
      <div className="hero-counter">{String(idx+1).padStart(2,"0")} / {String(HOME_IMAGES.length).padStart(2,"0")}</div>
    </div>
  );
}

// ─── Section Label ───
function Label({children,color="#f59e0b"}) {
  return (
    <div className="section-label" style={{color}}>
      <span className="label-line" style={{background:color}}/>
      {children}
    </div>
  );
}

// ─── Initiative Card ───
function ICard({icon:Icon, title, desc, color, tag}) {
  return (
    <div className="icard" style={{"--c":color}}>
      <div className="icard-top">
        <div className="icard-icon-wrap"><Icon size={22} color={color}/></div>
        {tag && <span className="icard-tag" style={{color,background:`${color}18`,border:`1px solid ${color}33`}}>{tag}</span>}
      </div>
      <h3 className="icard-title">{title}</h3>
      <p className="icard-desc">{desc}</p>
      <div className="icard-line" style={{background:`linear-gradient(90deg,${color},transparent)`}}/>
    </div>
  );
}

// ─── Home Tab ───
function HomeTab({goTo}) {
  return (
    <div>
      <HeroCarousel goTo={goTo}/>

      <Campaigns/>   {/* ← add this */}


      {/* Stats Band */}
      <div className="stats-band">
        <StatPill icon={School} label="Children Educated" value="246" suffix="+" color="#f59e0b"/>
        <StatPill icon={Heart} label="Sanitary Pads" value="68563" suffix="+" color="#ec4899"/>
        <StatPill icon={Users} label="Women Empowered" value="752" suffix="+" color="#a855f7"/>
        <StatPill icon={Leaf} label="Trees Planted" value="34562" suffix="+" color="#22c55e"/>
        <StatPill icon={Star} label="Animals Helped" value="2635" suffix="+" color="#3b82f6"/>
        <StatPill icon={Globe} label="Community Drives" value="50" suffix="+" color="#f97316"/>
      </div>

      {/* Initiatives */}
      <div className="section-wrap">
        <div className="section-header-row">
          <div>
            <Label>What We Do</Label>
            <h2 className="section-h2">Key Initiatives</h2>
          </div>
          <p className="section-tagline">Six pillars shaping a better tomorrow</p>
        </div>
        <div className="init-grid">
          <ICard icon={BookOpen} title="Shiksha Sanskar Campaign" tag="Education" color="#3b82f6"
            desc="Free education & extracurricular activities for 150+ underprivileged children in slums"/>
          <ICard icon={Heart} title="Menstrual Health Mission" tag="Healthcare" color="#ec4899"
            desc="Distributing 1 lakh sanitary pads & creating employment opportunities for women"/>
          <ICard icon={Sprout} title="Green Warriors" tag="Environment" color="#22c55e"
            desc="Plantation drives & pollution awareness programs with local communities"/>
          <ICard icon={Utensils} title="Food Security Drive" tag="Nutrition" color="#f97316"
            desc="Weekly nutritious meals for children and families in need across Ghaziabad"/>
          <ICard icon={Recycle} title="Unusable Goods Campaign" tag="Community" color="#06b6d4"
            desc="Collecting and redistributing usable goods to those who need them most"/>
          <ICard icon={ShieldCheck} title="Animal Welfare" tag="Rescue" color="#a855f7"
            desc="Rescue, care, and rehabilitation programs for stray and injured animals"/>
        </div>
      </div>

      {/* Vision / Mission */}
      <div className="vm-section">
        <div className="vm-grid">
          <div className="vm-card vm-vision">
            <div className="vm-icon-wrap"><Star size={28} color="#f59e0b"/></div>
            <Label color="#f59e0b">Our Vision</Label>
            <p className="vm-text">An India where no one is deprived of basic needs, and all citizens are empowered socially, economically, and culturally.</p>
          </div>
          <div className="vm-card vm-mission">
            <div className="vm-icon-wrap"><Globe size={28} color="#3b82f6"/></div>
            <Label color="#3b82f6">Our Mission</Label>
            <p className="vm-text">Eradicate social inequalities through education, women empowerment, and environmental conservation initiatives across the nation.</p>
          </div>
        </div>
      </div>

      {/* CTA Banner */}
      <div className="cta-banner">
        <div className="cta-inner">
          <div className="cta-text-block">
            <h2 className="cta-h2">Every Rupee Creates a Story</h2>
            <p className="cta-p">Your contribution directly reaches those who need it most — no middlemen, full transparency.</p>
          </div>
          <div className="cta-actions">
            <button onClick={()=>goTo(4)} className="btn-primary btn-lg">
              <Heart size={18} fill="currentColor"/> Support Now
            </button>
            <button onClick={()=>goTo(6)} className="btn-ghost-dark">
              View Gallery <ArrowUpRight size={16}/>
            </button>
          </div>
        </div>
      </div>
    <AnnouncementsBanner/>
      <SiteFooter/>
    </div>
  );
}

// ─── Expandable SDG Card ───
function SdgCard({emoji,title,sub,color,points}) {
  const [open,setOpen]=useState(false);
  return (
    <div className={`sdg-card${open?" sdg-open":""}`} style={{"--c":color}} onClick={()=>setOpen(o=>!o)}>
      <div className="sdg-head">
        <div className="sdg-emoji">{emoji}</div>
        <div className="sdg-info">
          <div className="sdg-title" style={{color}}>{title}</div>
          <div className="sdg-sub">{sub}</div>
        </div>
        <ChevronDown size={18} color={color} className={`sdg-chevron${open?" rotated":""}`}/>
      </div>
      {open && (
        <div className="sdg-body">
          {points.map(p=>(
            <div key={p} className="sdg-point">
              <CheckCircle size={15} color={color} style={{flexShrink:0,marginTop:2}}/>
              <span>{p}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── About Tab ───
function AboutTab() {
  return (
    <div>
      <div className="page-hero" style={{background:"linear-gradient(135deg,#0f172a 0%,#1e293b 50%,#0f172a 100%)"}}>
        <div className="page-hero-noise"/>
        <Label color="#f59e0b">Our Story</Label>
        <h1 className="page-hero-h1">Transforming Lives<br/><span style={{color:"#f59e0b"}}>Since 2020</span></h1>
        <p className="page-hero-p">Founded in Ghaziabad, Uttar Pradesh, Help Them Shine Trust has grown from a local initiative to a nationally recognized NGO impacting hundreds of thousands of beneficiaries.</p>
      </div>

      <div className="section-wrap">
        <Label>Who We Are</Label>
        <h2 className="section-h2" style={{marginBottom:32}}>Our Philosophy</h2>
        <div className="phil-grid">
          {[
            {icon:Star,color:"#f59e0b",title:"Vision",text:"Create an equitable society where every individual has access to opportunities for growth, dignity, and sustainable living."},
            {icon:Globe,color:"#ef4444",title:"Mission",text:"Empower marginalized communities through education, skill development, and environmental stewardship while promoting gender equality."},
            {icon:Heart,color:"#ec4899",title:"Values",text:"Transparency · Inclusivity · Sustainability · Innovation · Compassion"},
          ].map(({icon:I,color,title,text})=>(
            <div key={title} className="phil-card" style={{"--c":color}}>
              <div className="phil-icon-wrap" style={{background:`${color}18`}}><I size={28} color={color}/></div>
              <h3 style={{color,fontFamily:"'Playfair Display',serif",fontSize:22,margin:"14px 0 8px"}}>{title}</h3>
              <p style={{color:"#94a3b8",lineHeight:1.7,fontSize:14,margin:0}}>{text}</p>
            </div>
          ))}
        </div>

        <div style={{height:56}}/>
        <Label>Timeline</Label>
        <h2 className="section-h2" style={{marginBottom:32}}>Our Journey</h2>
        <div className="journey-grid">
          {[
            {year:"2020",title:"Foundation Established",text:"Registered under Indian Trust Act with initial focus on education and women empowerment in Ghaziabad slums"},
            {year:"2021",title:"National Expansion",text:"Launched environmental initiatives and expanded operations to 5 states with 50+ volunteers"},
            {year:"2022",title:"Digital Transformation",text:"Introduced digital education programs and mobile apps for skill development tracking"},
            {year:"2023",title:"Award-Winning NGO",text:"Recognized by Government of India for outstanding contribution to SDG implementation"},
          ].map(({year,title,text},i)=>(
            <div key={year} className="journey-card" style={{"--i":i}}>
              <div className="journey-year">{year}</div>
              <h4 className="journey-title">{title}</h4>
              <p className="journey-text">{text}</p>
            </div>
          ))}
        </div>

        <div style={{height:56}}/>
        <Label>Impact Areas</Label>
        <h2 className="section-h2" style={{marginBottom:24}}>Core Focus Areas</h2>
        <p style={{color:"#94a3b8",marginBottom:32,fontSize:15}}>Aligned with the UN Sustainable Development Goals</p>
        <div className="sdg-stack">
          <SdgCard emoji="🎓" title="Education Revolution" sub="Bridging the Learning Gap" color="#3b82f6"
            points={["Mobile Learning Units reaching remote areas daily","200 smart digital classrooms established","5,000+ students with full academic funding","1,200 educators certified in modern methods","85% success rate in night school programs"]}/>
          <SdgCard emoji="🚺" title="Women Leadership" sub="Creating Economic Independence" color="#ec4899"
            points={["25+ vocational courses including AI basics","₹5Cr+ disbursed through 0% interest loans","100+ menstrual health camps annually","350+ domestic violence cases resolved","E-commerce platform for women entrepreneurs"]}/>
          <SdgCard emoji="🌍" title="Green Future" sub="Sustainable Ecosystem Development" color="#22c55e"
            points={["50+ native species plantation drives","25 metric tons recycled monthly","120 schools powered by solar energy","500+ rainwater harvesting systems installed","1M+ students engaged through climate curriculum"]}/>
        </div>
      </div>
      <SiteFooter/>
    </div>
  );
}

// ─── Join Us ───
function JoinUsTab() {
  const [regOpen, setRegOpen] = useState(false);
  const [regType, setRegType] = useState("volunteer");

  function openReg(t) { setRegType(t); setRegOpen(true); }

  const ROLES = [
  {
    type: "volunteer", title: "Volunteer", icon: Users, color: "#3b82f6",
    tagline: "Join HTS Trust as a Volunteer and contribute your time and skills.",
    benefits: ["Flexible time commitment", "Skill development workshops", "Networking opportunities", "Participation certificates"],
    cta: "Register as Volunteer",
  },
  {
    type: "member", title: "Member", icon: Award, color: "#22c55e",
    tagline: "Become an HTS Trust Member and take on leadership roles.",
    benefits: ["Leadership roles", "Project management experience", "Professional references", "Team building activities"],
    cta: "Register as Member",
  },
  {
    type: "intern", title: "Intern", icon: GraduationCap, color: "#f59e0b",
    tagline: "Join HTS Trust as an Intern for real-world social impact experience.",
    benefits: ["3–12 months · Min 8 hrs/week", "Performance-based certificate & skill matrix", "Permanent volunteer role + Letter of Recommendation"],
    cta: "Apply as Intern",
  },
];

  const WHY = [
    { icon: Target,     title: "Make an Impact",              text: "Contribute directly to meaningful community initiatives." },
    { icon: TrendingUp, title: "Build Leadership Skills",      text: "Take responsibility and participate in real projects." },
    { icon: BookOpen,   title: "Learn & Grow",                 text: "Develop practical skills through workshops and field activities." },
    { icon: Handshake,  title: "Become Part of a Community",   text: "Work alongside people who care about creating positive change." },
    { icon: Medal,      title: "Recognition & Certification",  text: "Receive relevant certificates/recognition according to the existing HTS process." },
    { icon: Award,      title: "Welcome Kit",                  text: "Eligible registered participants receive the existing HTS Trust welcome kit." },
  ];

  const STEPS = [
    { n: "01", title: "Choose Your Role",                  text: "Volunteer, Intern or Member." },
    { n: "02", title: "Complete Registration",             text: "Submit your details and required documents." },
    { n: "03", title: "Complete Annual Registration Payment", text: "Pay the applicable annual registration fee." },
    { n: "04", title: "Verification & Confirmation",       text: "HTS Trust reviews and verifies the application." },
  ];

  return (
    <div>
      {/* Hero */}
      <div className="jn-hero">
        <div className="page-hero-noise" />
        <div className="jn-hero-deco jn-hero-deco-1"><Heart size={22} /></div>
        <div className="jn-hero-deco jn-hero-deco-2"><Users size={24} /></div>
        <div className="jn-hero-deco jn-hero-deco-3"><Globe size={20} /></div>
        <Label color="#fb923c">Get Involved</Label>
        <h1 className="page-hero-h1">Be The<br /><span style={{ color: "#fb923c" }}>Change Maker</span></h1>
        <p className="page-hero-p">Choose your preferred way to contribute and make a real difference in people's lives.</p>
      </div>

      <div className="section-wrap">
        <div className="jn-section-head">
          <Label>Get Started</Label>
          <h2 className="section-h2">Choose How You Want to Contribute</h2>
        </div>

        {/* 3 registration cards */}
        <div className="jn-cards-grid">
          {ROLES.map((r, i) => (
            <div key={r.type} className="jn-card" style={{ "--c": r.color, "--i": i }}>
              <div className="jn-card-icon-wrap" style={{ background: `${r.color}22` }}>
                <r.icon size={26} color={r.color} />
              </div>
              <h3 className="jn-card-title">{r.title}</h3>
              <p className="jn-card-tagline">{r.tagline}</p>
              
              <div className="jn-card-benefits">
                {r.benefits.map(b => (
                  <div key={b} className="jn-card-benefit">
                    <CheckCircle size={14} color={r.color} style={{ flexShrink: 0, marginTop: 2 }} />
                    <span>{b}</span>
                  </div>
                ))}
              </div>
              <button className="jn-card-cta" style={{ background: r.color }} onClick={() => openReg(r.type)}>
                {r.cta} <ArrowRight size={15} className="jn-cta-arrow" />
              </button>
            </div>
          ))}
        </div>

        {/* Annual renewal notice */}
        <div className="jn-notice">
          <Repeat size={14} color="#f59e0b" />
          Registration is valid for one year and requires annual renewal.
        </div>

        {/* Past interns */}
        <div className="uni-row" style={{ marginTop: 36 }}>
          <div className="uni-label">Past Interns From</div>
          <div className="uni-chips">
            {["Jaipuriya University", "Amity University", "Sunder Deep College", "IME College", "ITS Engineering College", "Mewar University", "LR College"].map(u => (
              <span key={u} className="uni-chip">{u}</span>
            ))}
          </div>
        </div>
      </div>

      {/* Why Join HTS */}
      <div className="jn-why-section">
        <div className="section-wrap" style={{ padding: "64px 24px" }}>
          <div className="jn-section-head">
            <Label color="#3b82f6">Why HTS</Label>
            <h2 className="section-h2">Why Join HTS Trust?</h2>
          </div>
          <div className="jn-why-grid">
            {WHY.map(({ icon: I, title, text }) => (
              <div key={title} className="jn-why-card">
                <div className="jn-why-icon"><I size={20} color="#f59e0b" /></div>
                <div className="jn-why-title">{title}</div>
                <div className="jn-why-text">{text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* How It Works */}
      <div className="section-wrap">
        <div className="jn-section-head">
          <Label color="#a855f7">Process</Label>
          <h2 className="section-h2">How Registration Works</h2>
        </div>
        <div className="jn-steps-row">
          {STEPS.map(s => (
            <div key={s.n} className="jn-step">
              <div className="jn-step-num">{s.n}</div>
              <div className="jn-step-title">{s.title}</div>
              <div className="jn-step-text">{s.text}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Final CTA */}
      <div className="cta-banner">
        <div className="cta-inner">
          <div className="cta-text-block">
            <h2 className="cta-h2">Ready to Make a Difference?</h2>
            <p className="cta-p">Join volunteers, members and interns already contributing to HTS Trust's mission.</p>
          </div>
          <div className="cta-actions">
            <button onClick={() => openReg("volunteer")} className="btn-primary btn-lg">
              <Heart size={18} fill="currentColor" /> Get Started
            </button>
          </div>
        </div>
      </div>

      {regOpen && <VolunteerRegistrationModal defaultType={regType} onClose={() => setRegOpen(false)} />}
      <SiteFooter />
    </div>
  );
}

// ─── Contact ───
function ContactTab() {
  return (
    <div>
      <div className="page-hero" style={{background:"linear-gradient(135deg,#0c4a6e 0%,#0369a1 50%,#0c4a6e 100%)"}}>
        <div className="page-hero-noise"/>
        <Label color="#38bdf8">Connect</Label>
        <h1 className="page-hero-h1">Get In <span style={{color:"#38bdf8"}}>Touch</span></h1>
        <p className="page-hero-p">We're here to help. Reach out anytime and we'll respond within 24 hours.</p>
      </div>
      <div className="section-wrap">
        <div className="contact-grid">
          <div className="contact-info-col">
            <Label color="#f59e0b">Offices</Label>
            <h2 className="section-h2" style={{marginBottom:24}}>Find Us</h2>
            <div className="office-card">
              <div className="office-label">Registered Office</div>
              <div className="office-address">412, Street-2, Shyam Park Main,<br/>Sahibabad, Ghaziabad,<br/>Uttar Pradesh 201005, INDIA</div>
            </div>
            <div className="office-card" style={{marginTop:16}}>
              <div className="office-label">Branch Office</div>
              <div className="office-address">Shop No. 15, Hindon Complex,<br/>Near Hindon Air Force Gol Chakkar,<br/>New Karhera Colony, Mohan Nagar,<br/>Ghaziabad, UP 201007</div>
              <a href="https://maps.app.goo.gl/3VPtfumX1XWHj73X9" target="_blank" rel="noreferrer" className="map-link">
                <MapPin size={14}/> Open in Maps <ArrowUpRight size={13}/>
              </a>
            </div>
            <div className="contact-reach">
              {[
                {icon:Phone,label:"Primary",val:"+91 7669990505",href:"tel:7669990505"},
                {icon:Phone,label:"Alternate",val:"+91 7669990507",href:"tel:7669990507"},
                {icon:Mail,label:"Email",val:"htstrust@gmail.com",href:"mailto:htstrust@gmail.com"},
              ].map(({icon:I,label,val,href})=>(
                <a key={label} href={href} className="reach-row">
                  <I size={18} color="#f59e0b"/>
                  <div>
                    <div className="reach-label">{label}</div>
                    <div className="reach-val">{val}</div>
                  </div>
                </a>
              ))}
            </div>
          </div>
          <div className="social-col">
            <Label color="#f59e0b">Follow</Label>
            <h2 className="section-h2" style={{marginBottom:24}}>Stay Connected</h2>
            <div className="social-cards">
              {[
                {label:"YouTube",color:"#ff0000",href:"https://www.youtube.com/@htstrust",img:"https://ik.imagekit.io/htst/images/youtube.png?updatedAt=1745302131292",handle:"@htstrust"},
                {label:"Instagram",color:"#e1306c",href:"https://www.instagram.com/htstrust/",img:"https://ik.imagekit.io/htst/images/insta.png?updatedAt=1745302130972",handle:"@htstrust"},
                {label:"Facebook",color:"#1877f2",href:"https://www.facebook.com/Helpthemshinetrust",img:"https://res.cloudinary.com/dfqc7ya5j/image/upload/v1743864034/687643d0-d17b-46ed-9016-1d6cdb51ea16.png",handle:"Helpthemshinetrust"},
                {label:"X / Twitter",color:"#000000",href:"https://x.com/htstrust",img:"https://ik.imagekit.io/htst/images/x.png?updatedAt=1745302131551",handle:"@htstrust"},
              ].map(({label,color,href,img,handle})=>(
                <a key={label} href={href} target="_blank" rel="noreferrer" className="social-card" style={{"--c":color}}>
                  <img src={img} alt={label} className="social-icon" onError={e=>e.target.style.display="none"}/>
                  <div>
                    <div className="social-name">{label}</div>
                    <div className="social-handle">{handle}</div>
                  </div>
                  <ArrowUpRight size={16} color={color} style={{marginLeft:"auto"}}/>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <SiteFooter/>
    </div>
  );
}

// ─── Donate ───
function DonateTab() {
  const items = [
    {icon:Pencil,title:"Stationery",color:"#3b82f6",list:["Notebooks","Pens/Pencils","Art Supplies","School Bags"]},
    {icon:Shirt,title:"Clothes",color:"#8b5cf6",list:["New/Good Condition","All Sizes","Seasonal Wear","Winter Specials"]},
    {icon:Utensils,title:"Food",color:"#f97316",list:["Dry Rations","Packed Food","Nutrition Kits","Baby Food"]},
    {icon:Heart,title:"Hygiene",color:"#ec4899",list:["Sanitary Pads","Soaps","Toothpaste","Disinfectants"]},
    {icon:ShieldCheck,title:"Medical",color:"#10b981",list:["OTC Medicines","First Aid Kits","Mobility Aids","Therapy Items"]},
    {icon:Sprout,title:"Eco Items",color:"#14b8a6",list:["Saplings","Gardening Tools","Compost Kits","Eco-bricks"]},
  ];
  return (
    <div>
      <div className="page-hero" style={{background:"linear-gradient(135deg,#78350f 0%,#92400e 50%,#78350f 100%)"}}>
        <div className="page-hero-noise"/>
        <Label color="#fbbf24">Make a Difference</Label>
        <h1 className="page-hero-h1">Every Rupee<br/><span style={{color:"#fbbf24"}}>Matters</span></h1>
        <p className="page-hero-p">Your contribution, big or small, directly touches lives and builds a better India.</p>
      </div>
      <div className="section-wrap">
        {/* Payment cards */}
        <Label>Give Now</Label>
        <h2 className="section-h2" style={{marginBottom:32}}>Financial Support</h2>
        <div className="donate-grid">
          <div className="donate-card donate-upi">
            <div className="donate-card-label"><CreditCard size={18} color="#10b981"/> Scan & Pay via UPI</div>
            <div className="upi-qr-wrap">
              <img src="https://ik.imagekit.io/htst/images/upi.jpg?updatedAt=1745299149818" alt="UPI QR" className="upi-qr"
                onError={e=>e.target.style.display="none"}/>
            </div>
            <p className="donate-note">Compatible with PhonePe, GPay, Paytm &amp; all UPI apps</p>
          </div>
          
          <div className="donate-card donate-bank">
            <div className="donate-card-label"><Banknote size={18} color="#3b82f6"/> Direct Bank Transfer</div>
            <div className="bank-rows">
              {[["Account Name","HELP THEM SHINE TRUST"],["Account Number","50200052424207"],["IFSC Code","HDFC0000153"],["Bank","HDFC Bank Ltd."]].map(([k,v])=>(
                <div key={k} className="bank-row">
                  <span className="bank-key">{k}</span><span className="bank-val">{v}</span>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 18, display: "flex", justifyContent: "center" }}>
  <RazorpayButton key="donation" buttonId="pl_TdXjlaQQtQZrfs" />
</div>
          </div>
        </div>

        {/* Tax + Guidelines */}
        <div className="tax-grid">
          <div className="tax-card">
            <ShieldCheck size={24} color="#22c55e"/>
            <h4 style={{color:"#22c55e",fontWeight:700,margin:"10px 0 12px",fontSize:17}}>Tax Benefits</h4>
            {["80G Tax Exemption","12A Registration Valid","CSR Compliant","Instant exemption certificates"].map(t=>(
              <div key={t} className="tax-row"><CheckCircle size={14} color="#22c55e"/><span>{t}</span></div>
            ))}
          </div>
          <div className="tax-card">
            <AlertTriangle size={24} color="#f59e0b"/>
            <h4 style={{color:"#f59e0b",fontWeight:700,margin:"10px 0 12px",fontSize:17}}>Donation Guidelines</h4>
            {[
              {ok:true,t:"Clean, gently used items in good condition"},
              {ok:true,t:"Non-expired medicines & hygiene products"},
              {ok:true,t:"Functional stationery & usable plants"},
              {ok:false,t:"Damaged/torn/stained items"},
              {ok:false,t:"Broken or hazardous materials"},
            ].map(({ok,t})=>(
              <div key={t} className="tax-row">
                <span style={{color:ok?"#22c55e":"#ef4444",fontWeight:900,fontSize:16}}>{ok?"✓":"✗"}</span>
                <span>{t}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Items */}
        <Label>In-Kind Donations</Label>
        <h2 className="section-h2" style={{marginBottom:32}}>Essential Items</h2>
        <div className="items-grid">
          {items.map(({icon:I,title,color,list})=>(
            <div key={title} className="item-card" style={{"--c":color}}>
              <div className="item-icon-wrap" style={{background:`${color}18`}}><I size={26} color={color}/></div>
              <div className="item-title" style={{color}}>{title}</div>
              {list.map(l=><div key={l} className="item-bullet">— {l}</div>)}
            </div>
          ))}
        </div>

        {/* Emergency */}
        <div className="emergency-card">
          <Phone size={22} color="#ef4444"/>
          <div>
            <div className="emergency-title">Immediate Assistance — 24/7</div>
            <div className="emergency-sub">Call us for urgent donation drop-offs or assistance</div>
          </div>
          <a href="tel:7669990505" className="emergency-call">Call 7669990505</a>
        </div>
      </div>
      <SiteFooter/>
    </div>
  );
}

// ─── Certifications ───
function CertsTab() {
  const [sel,setSel]=useState(null);
  return (
    <div>
      <div className="page-hero" style={{background:"linear-gradient(135deg,#1e1b4b 0%,#2e1065 50%,#1e1b4b 100%)"}}>
        <div className="page-hero-noise"/>
        <Label color="#a78bfa">Verified</Label>
        <h1 className="page-hero-h1">Our <span style={{color:"#a78bfa"}}>Certifications</span></h1>
        <p className="page-hero-p">Official accreditations validating our operations and compliance with Indian regulations</p>
      </div>
      <div className="section-wrap">
        <div className="certs-grid">
          {CERTS.map((c,i)=>(
            <div key={i} className="cert-card" onClick={()=>setSel(c)}>
              <div className="cert-img-wrap">
                <img src={c.path} alt={c.title} className="cert-img" onError={e=>e.target.style.display="none"}/>
                <div className="cert-overlay">
                  <ZoomIn size={24} color="#fff"/>
                </div>
                <div className="cert-num">#{i+1}</div>
              </div>
              <div className="cert-info">
                <div className="cert-title">{c.title}</div>
                <div className="cert-by">{c.by}</div>
                <div className="cert-year">{c.year}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {sel && (
        <div className="lightbox" onClick={()=>setSel(null)}>
          <div className="lightbox-inner" onClick={e=>e.stopPropagation()}>
            <button className="lb-close" onClick={()=>setSel(null)}><X size={18}/></button>
            <img src={sel.path} alt={sel.title} className="lb-img"/>
            <div className="lb-caption">
              <div className="lb-cap-title">{sel.title}</div>
              <div className="lb-cap-sub">{sel.by} · {sel.year}</div>
            </div>
          </div>
        </div>
      )}
      <SiteFooter/>
    </div>
  );
}

// ─── Gallery ───
function GalleryTab() {
  const [catIdx,setCatIdx]=useState(0);
  const [shown,setShown]=useState(18);
  const [sel,setSel]=useState(null);
  const cat=GALLERY_CATS[catIdx];
  const images=genImages(cat,cat.count);
  useEffect(()=>setShown(18),[catIdx]);
  return (
    <div>
      <div className="gallery-hero" style={{background:`linear-gradient(135deg,${cat.color}33,${cat.color}11)`}}>
        <div className="gallery-hero-emoji">{cat.emoji}</div>
        <div>
          <h2 className="gallery-hero-title">{cat.label}</h2>
          <div className="gallery-hero-count">{cat.count} photographs</div>
        </div>
      </div>

      {/* Pill bar */}
      <div className="cat-bar">
        {GALLERY_CATS.map((c,i)=>(
          <button key={c.key} onClick={()=>setCatIdx(i)} className={`cat-pill${i===catIdx?" active":""}`}
            style={i===catIdx?{background:c.color,borderColor:c.color,color:"#fff"}:{}}>
            {c.emoji} {c.label}
          </button>
        ))}
      </div>

      {/* Grid */}
      <div className="gallery-grid">
        {images.slice(0,shown).map((src,i)=>(
          <div key={i} className="gallery-item" onClick={()=>setSel(src)}>
            <img src={src} alt={`${cat.label} ${i+1}`} loading="lazy" className="gallery-img"
              onError={e=>e.target.style.display="none"}/>
            <div className="gallery-overlay">
              <ZoomIn size={20} color="#fff"/>
            </div>
            <div className="gallery-num">#{i+1}</div>
          </div>
        ))}
      </div>

      {shown<images.length && (
        <div style={{textAlign:"center",padding:"32px 0 48px"}}>
          <button onClick={()=>setShown(n=>n+18)} className="load-more-btn">
            Load More · {images.length-shown} remaining
          </button>
        </div>
      )}

      {sel && (
        <div className="lightbox" onClick={()=>setSel(null)}>
          <div onClick={e=>e.stopPropagation()} style={{position:"relative"}}>
            <button className="lb-close" onClick={()=>setSel(null)}><X size={18}/></button>
            <img src={sel} alt="" className="lb-img"/>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Footer ───
function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src={trustLogo} alt="HTS Trust" className="footer-logo"/>
          <div className="footer-brand-name">Help Them Shine Trust</div>
          <div className="footer-tagline">Transforming Lives Since 2020</div>
        </div>
        <div className="footer-meta">
          <div className="footer-reg">Legally Constituted and Registered Under Indian Trust Act 1882, Government of India</div>
          <div className="footer-reg">Regd. No. 1767/2020 · Unique ID: UP/2020/0261664</div>
          <div className="footer-reg">12(A) / 80(G) Income Tax Act 1961 · Contributions Eligible For Income Tax Benefit</div>
        </div>
      </div>
    </footer>
  );
}

// ─── Main App ───
export default function App() {
  const [tab,setTab]=useState(0);
  const [menuOpen,setMenuOpen]=useState(false);

  useEffect(()=>{ setFavicon(); },[]);

  useEffect(()=>{
    const h=(e)=>{ setTab(e.detail); setMenuOpen(false); window.scrollTo({top:0,behavior:"smooth"}); };
    window.addEventListener("gotoTab",h);
    return()=>window.removeEventListener("gotoTab",h);
  },[]);

  const goTo=(i)=>{ setTab(i); setMenuOpen(false); window.scrollTo({top:0,behavior:"smooth"}); };

  const tabs=[
    <HomeTab key="home" goTo={goTo}/>,
    <AboutTab key="about"/>,
    <JoinUsTab key="join"/>,
    <ContactTab key="contact"/>,
    <DonateTab key="donate"/>,
    <CertsTab key="certs"/>,
    <GalleryTab key="gallery"/>,
  ];

  return (
    <div className="app-root">
      <EventPopup/>
      <CampaignPopup/>
      <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800;900&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
      <style>{CSS}</style>

      {/* Nav */}
      <header className={`navbar${menuOpen?" open":""}`}>
        <div className="navbar-inner">
          <button className="nav-logo-btn" onClick={()=>goTo(0)}>
            <img src={trustLogo} alt="HTS" className="nav-logo-img"/>
            <div>
              <div className="nav-brand">Help Them Shine</div>
              <div className="nav-sub">Trust · Est. 2020</div>
            </div>
          </button>

          <nav className="nav-links">
            {TABS.map((t,i)=>(
              <button key={t} onClick={()=>goTo(i)} className={`nav-link${tab===i?" active":""}`}>{t}</button>
            ))}
          </nav>

          <div className="nav-right">
  <Link to="/login" style={{
  display:"inline-flex", alignItems:"center", gap:6,
  background:"rgba(255,255,255,0.12)",
  color:"#fff",
  border:"1px solid rgba(255,255,255,0.25)",
  padding:"7px 18px", borderRadius:50,
  fontWeight:700, fontSize:13, textDecoration:"none",
  transition:"all 0.2s", whiteSpace:"nowrap"
}}>
  👤 Login
</Link>
  <button onClick={()=>goTo(4)} className="nav-donate-btn">
    <Heart size={14} fill="currentColor"/> Donate
  </button>
  <button className="hamburger" onClick={()=>setMenuOpen(o=>!o)}>
    {menuOpen?<X size={22}/>:<Menu size={22}/>}
  </button>
</div>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="mobile-menu">
            {TABS.map((t,i)=>(
              <button key={t} onClick={()=>goTo(i)} className={`mobile-link${tab===i?" active":""}`}>{t}</button>
            ))}
          </div>
        )}
      </header>

      <main>{tabs[tab]}</main>
    </div>
  );
}

// ─── CSS ───
const CSS = `
  :root {
    /* ── Surface elevation scale (depth, not flat black) ── */
    --bg-base:      #0a0908;
    --bg-sunken:     #060504;
    --bg-alt:        #0d0c0a;
    --surface-1:     #111009;
    --surface-2:     #161410;
    --surface-elevated: #1a1714;

    /* ── Borders ── */
    --border-subtle:  rgba(255,255,255,0.06);
    --border-default: rgba(255,255,255,0.09);
    --border-strong:  rgba(255,255,255,0.16);
    --border-accent:  rgba(245,158,11,0.3);

    /* ── Text hierarchy ── */
    --text-primary:   #fef3e2;
    --text-secondary: #a8a29e;
    --text-muted:     #78716c;
    --text-faint:     #52504d;

    /* ── Accent ── */
    --accent:         #f59e0b;
    --accent-hover:   #fbbf24;
    --accent-soft:    rgba(245,158,11,0.12);

    /* ── Radius scale ── */
    --r-sm: 8px;
    --r-md: 12px;
    --r-lg: 16px;
    --r-xl: 20px;
    --r-full: 999px;

    /* ── Spacing scale ── */
    --sp-xs: 8px;  --sp-sm: 12px; --sp-md: 20px;
    --sp-lg: 32px; --sp-xl: 48px; --sp-2xl: 72px;

    /* ── Motion ── */
    --ease: cubic-bezier(0.4, 0, 0.2, 1);
    --dur-fast: 0.15s;
    --dur-base: 0.25s;

    /* ── Shadow ── */
    --shadow-sm: 0 2px 10px rgba(0,0,0,0.25);
    --shadow-md: 0 8px 28px rgba(0,0,0,0.35);
    --shadow-lg: 0 20px 50px rgba(0,0,0,0.5);
    --shadow-glow: 0 8px 24px -6px rgba(245,158,11,0.35);
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }

  body, .app-root {
    font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
    background: #0a0908;
    color: #e2d9d0;
    min-height: 100vh;
  }

    /* ── NAVBAR (v2) ── */
  .navbar {
    position: sticky; top: 0; z-index: 200;
    background: rgba(10,9,8,0.7);
    backdrop-filter: blur(24px) saturate(1.4);
    -webkit-backdrop-filter: blur(24px) saturate(1.4);
    border-bottom: 1px solid var(--border-subtle);
    transition: background var(--dur-base) var(--ease), border-color var(--dur-base) var(--ease);
  }
  .navbar-inner {
    max-width: 1280px; margin: 0 auto;
    display: flex; align-items: center;
    padding: 0 24px; height: 72px; gap: 20px;
  }
  .nav-logo-btn {
    display: flex; align-items: center; gap: 12px;
    background: none; border: none; cursor: pointer; flex-shrink: 0;
    transition: opacity var(--dur-fast) var(--ease);
  }
  .nav-logo-btn:hover { opacity: 0.85; }
  .nav-logo-img { width: 40px; height: 40px; object-fit: contain; border-radius: var(--r-sm); }
  .nav-brand { font-family: 'Playfair Display', serif; font-size: 16px; font-weight: 800; color: var(--text-primary); line-height: 1.2; }
  .nav-sub { font-size: 10px; color: var(--text-muted); font-weight: 600; letter-spacing: 1px; text-transform: uppercase; }

  .nav-links { display: flex; gap: 2px; margin-left: auto; background: rgba(255,255,255,0.03); padding: 4px; border-radius: var(--r-full); border: 1px solid var(--border-subtle); }
  .nav-link {
    position: relative;
    background: none; border: none; cursor: pointer;
    color: var(--text-secondary); font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px; font-weight: 600; padding: 8px 16px;
    border-radius: var(--r-full); transition: color var(--dur-fast) var(--ease), background var(--dur-fast) var(--ease);
    white-space: nowrap;
  }
  .nav-link:hover { color: var(--text-primary); }
  .nav-link:focus-visible { outline: 2px solid var(--accent); outline-offset: 2px; }
  .nav-link.active { color: #0a0908; background: var(--accent); font-weight: 700; }

  .nav-right { display: flex; align-items: center; gap: 10px; margin-left: 12px; }
  .nav-donate-btn {
    display: flex; align-items: center; gap: 6px;
    background: var(--accent); color: #0a0908; border: none;
    padding: 9px 20px; border-radius: var(--r-full); font-weight: 800;
    font-size: 13px; cursor: pointer; transition: transform var(--dur-fast) var(--ease), box-shadow var(--dur-fast) var(--ease);
    font-family: 'Plus Jakarta Sans', sans-serif;
  }
  .nav-donate-btn:hover { transform: translateY(-1px); box-shadow: var(--shadow-glow); }
  .nav-donate-btn:active { transform: translateY(0); }

  .hamburger {
    display: none; background: rgba(255,255,255,0.06); border: 1px solid var(--border-subtle); border-radius: var(--r-sm);
    padding: 9px; color: var(--text-primary); cursor: pointer; transition: background var(--dur-fast) var(--ease);
  }
  .hamburger:hover { background: rgba(255,255,255,0.1); }
  .mobile-menu {
    background: var(--surface-1); border-top: 1px solid var(--border-subtle);
    display: flex; flex-direction: column;
    animation: navSlideDown 0.25s var(--ease);
  }
  @keyframes navSlideDown { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
  .mobile-link {
    background: none; border: none; cursor: pointer;
    color: var(--text-secondary); font-size: 15px; font-weight: 600;
    padding: 16px 28px; text-align: left; border-bottom: 1px solid var(--border-subtle);
    font-family: 'Plus Jakarta Sans', sans-serif; transition: color var(--dur-fast) var(--ease), background var(--dur-fast) var(--ease);
  }
  .mobile-link.active { color: var(--accent); background: var(--accent-soft); }
  /* ── HERO ── */
  .hero-wrap {
    position: relative; height: 100svh; min-height: 600px;
    max-height: 900px; overflow: hidden; background: #0a0908;
  }
  .hero-slide { position: absolute; inset: 0; transition: opacity 1s ease; }
  .hero-img { width: 100%; height: 100%; object-fit: cover; }
  .hero-vignette {
    position: absolute; inset: 0;
    background: linear-gradient(to bottom, rgba(10,9,8,0.3) 0%, rgba(10,9,8,0.15) 40%, rgba(10,9,8,0.75) 80%, rgba(10,9,8,0.95) 100%);
  }
  .hero-content {
    position: absolute; bottom: 0; left: 0; right: 0;
    padding: 48px 40px 36px; z-index: 3; max-width: 1280px; margin: 0 auto;
  }
  .hero-badge {
    display: inline-flex; align-items: center; gap: 8px;
    background: rgba(245,158,11,0.15); border: 1px solid rgba(245,158,11,0.3);
    color: #fbbf24; font-size: 12px; font-weight: 700;
    padding: 6px 14px; border-radius: 50px; letter-spacing: 0.5px;
    text-transform: uppercase; margin-bottom: 20px;
  }
  .hero-badge-dot { width: 6px; height: 6px; border-radius: 50%; background: #f59e0b; animation: blink 1.5s infinite; }
  @keyframes blink { 0%,100%{opacity:1} 50%{opacity:0.2} }
  .hero-title {
    font-family: 'Playfair Display', serif;
    font-size: clamp(48px, 8vw, 96px);
    font-weight: 900; color: #fef3e2; line-height: 1;
    display: flex; flex-direction: column; gap: 0; margin-bottom: 16px;
  }
  .hero-title-accent { color: #f59e0b; }
  .hero-sub { font-size: clamp(15px, 2vw, 18px); color: rgba(255,255,255,0.7); max-width: 560px; line-height: 1.65; margin-bottom: 28px; }
  .hero-btns { display: flex; gap: 14px; flex-wrap: wrap; margin-bottom: 36px; }

  .btn-primary {
    display: inline-flex; align-items: center; gap: 8px;
    background: #f59e0b; color: #0a0908;
    border: none; border-radius: 50px;
    padding: 14px 28px; font-size: 15px; font-weight: 800;
    cursor: pointer; transition: all 0.2s; font-family: 'Plus Jakarta Sans', sans-serif;
  }
  .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(245,158,11,0.4); }
  .btn-lg { padding: 16px 36px; font-size: 16px; }
  .btn-ghost {
    display: inline-flex; align-items: center; gap: 8px;
    background: rgba(255,255,255,0.1); color: #fef3e2;
    border: 1px solid rgba(255,255,255,0.2); border-radius: 50px;
    padding: 14px 28px; font-size: 15px; font-weight: 700;
    cursor: pointer; transition: all 0.2s; backdrop-filter: blur(8px);
    font-family: 'Plus Jakarta Sans', sans-serif;
  }
  .btn-ghost:hover { background: rgba(255,255,255,0.18); border-color: rgba(255,255,255,0.4); }
  .btn-ghost-dark {
    display: inline-flex; align-items: center; gap: 8px;
    background: transparent; color: #f59e0b;
    border: 2px solid rgba(245,158,11,0.4); border-radius: 50px;
    padding: 14px 28px; font-size: 15px; font-weight: 700;
    cursor: pointer; transition: all 0.2s; font-family: 'Plus Jakarta Sans', sans-serif;
  }
  .btn-ghost-dark:hover { border-color: #f59e0b; background: rgba(245,158,11,0.08); }

  .hero-micro-stats { display: flex; gap: 32px; flex-wrap: wrap; }
  .hero-micro { display: flex; flex-direction: column; gap: 2px; }
  .hero-micro-num { font-family: 'Playfair Display', serif; font-size: 24px; font-weight: 800; color: #f59e0b; }
  .hero-micro-lbl { font-size: 11px; color: rgba(255,255,255,0.5); font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; }

  .hero-arrow {
    position: absolute; top: 50%; transform: translateY(-50%);
    background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.15);
    color: #fff; border-radius: 50%; width: 48px; height: 48px;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; z-index: 4; backdrop-filter: blur(8px); transition: all 0.2s;
  }
  .hero-arrow:hover { background: rgba(245,158,11,0.3); border-color: #f59e0b; }
  .hero-arrow-l { left: 24px; }
  .hero-arrow-r { right: 24px; }
  .hero-dots { position: absolute; top: 24px; right: 72px; display: flex; gap: 6px; z-index: 4; }
  .hero-dot {
    width: 6px; height: 6px; border-radius: 50%; border: none;
    background: rgba(255,255,255,0.3); cursor: pointer; transition: all 0.3s; padding: 0;
  }
  .hero-dot.active { background: #f59e0b; width: 20px; border-radius: 3px; }
  .hero-counter {
    position: absolute; top: 24px; right: 24px; z-index: 4;
    font-size: 11px; font-weight: 800; color: rgba(255,255,255,0.4);
    letter-spacing: 2px; font-family: 'Plus Jakarta Sans', sans-serif;
  }

  /* ── STATS BAND ── */
  .stats-band {
    display: flex; flex-wrap: wrap; justify-content: center;
    gap: 12px; padding: 32px 24px;
    background: #111009; border-bottom: 1px solid rgba(255,255,255,0.05);
  }
  .stat-pill {
    display: flex; align-items: center; gap: 14px;
    background: #1a1714; border: 1px solid rgba(255,255,255,0.07);
    border-radius: 14px; padding: 14px 20px; min-width: 180px;
    transition: transform 0.2s;
  }
  .stat-pill:hover { transform: translateY(-2px); }
  .stat-pill-icon { border-radius: 10px; padding: 8px; display: flex; flex-shrink: 0; }
  .stat-num { font-family: 'Playfair Display', serif; font-size: 26px; font-weight: 800; line-height: 1; }
  .stat-lbl { font-size: 12px; color: #78716c; margin-top: 3px; font-weight: 600; }

  /* ── SECTIONS ── */
  .section-wrap { max-width: 1280px; margin: 0 auto; padding: 64px 24px; }
  .section-header-row { display: flex; align-items: flex-end; justify-content: space-between; margin-bottom: 40px; flex-wrap: wrap; gap: 16px; }
  .section-h2 { font-family: 'Playfair Display', serif; font-size: clamp(28px,4vw,42px); font-weight: 800; color: #fef3e2; line-height: 1.15; }
  .section-tagline { font-size: 14px; color: #78716c; max-width: 260px; text-align: right; line-height: 1.5; }
  .section-label { display: flex; align-items: center; gap: 10px; font-size: 12px; font-weight: 800; letter-spacing: 2px; text-transform: uppercase; margin-bottom: 10px; }
  .label-line { width: 28px; height: 2px; border-radius: 1px; flex-shrink: 0; }

  /* ── INITIATIVES ── */
  .init-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px,1fr)); gap: 16px; }
  .icard {
    background: #111009; border: 1px solid rgba(255,255,255,0.06);
    border-radius: 18px; padding: 24px; position: relative; overflow: hidden;
    transition: transform 0.25s, border-color 0.25s;
  }
  .icard:hover { transform: translateY(-4px); border-color: var(--c); }
  .icard-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }
  .icard-icon-wrap { background: rgba(255,255,255,0.06); border-radius: 12px; padding: 10px; display: flex; }
  .icard-tag { font-size: 10px; font-weight: 800; padding: 4px 10px; border-radius: 50px; letter-spacing: 0.5px; text-transform: uppercase; }
  .icard-title { font-family: 'Playfair Display', serif; font-size: 18px; font-weight: 700; color: #fef3e2; margin-bottom: 10px; line-height: 1.3; }
  .icard-desc { font-size: 13px; color: #78716c; line-height: 1.65; margin-bottom: 20px; }
  .icard-line { height: 2px; width: 40px; border-radius: 1px; }

  /* ── VISION/MISSION ── */
  .vm-section { background: #0d0c0a; border-top: 1px solid rgba(255,255,255,0.05); border-bottom: 1px solid rgba(255,255,255,0.05); padding: 64px 24px; }
  .vm-grid { max-width: 1280px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }
  .vm-card { background: #111009; border: 1px solid rgba(255,255,255,0.06); border-radius: 20px; padding: 40px; }
  .vm-icon-wrap { width: 56px; height: 56px; background: rgba(255,255,255,0.04); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin-bottom: 20px; }
  .vm-text { font-size: 16px; color: #a8a29e; line-height: 1.75; margin-top: 12px; }

  /* ── CTA BANNER ── */
  .cta-banner {
    background: linear-gradient(135deg, #1a0f00 0%, #2d1a00 50%, #1a0f00 100%);
    border-top: 1px solid rgba(245,158,11,0.15);
    padding: 64px 24px;
  }
  .cta-inner {
    max-width: 1280px; margin: 0 auto;
    display: flex; align-items: center; justify-content: space-between;
    gap: 32px; flex-wrap: wrap;
  }
  .cta-text-block { flex: 1; min-width: 260px; }
  .cta-h2 { font-family: 'Playfair Display', serif; font-size: clamp(24px,3.5vw,40px); font-weight: 800; color: #fef3e2; margin-bottom: 10px; }
  .cta-p { font-size: 15px; color: #78716c; line-height: 1.65; max-width: 440px; }
  .cta-actions { display: flex; gap: 14px; flex-wrap: wrap; }

  /* ── PAGE HERO ── */
  .page-hero {
    padding: 100px 40px 72px; text-align: center; position: relative; overflow: hidden;
  }
  .page-hero-noise {
    position: absolute; inset: 0; opacity: 0.03;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Cfilter id='n'%3E%3CfeTurbulence baseFrequency='0.9' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='300' height='300' filter='url(%23n)' opacity='1'/%3E%3C/svg%3E");
  }
  .page-hero-h1 { font-family: 'Playfair Display', serif; font-size: clamp(36px,6vw,72px); font-weight: 900; color: #fef3e2; line-height: 1.1; margin: 14px 0 18px; position: relative; z-index: 1; }
  .page-hero-p { font-size: clamp(14px,2vw,17px); color: rgba(255,255,255,0.65); max-width: 600px; margin: 0 auto; line-height: 1.7; position: relative; z-index: 1; }

  /* ── PHILOSOPHY ── */
  .phil-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px,1fr)); gap: 20px; margin-bottom: 16px; }
  .phil-card {
    background: #111009; border: 1px solid rgba(255,255,255,0.06);
    border-radius: 16px; padding: 28px; border-left: 3px solid var(--c);
    transition: transform 0.2s;
  }
  .phil-card:hover { transform: translateY(-3px); }
  .phil-icon-wrap { width: 52px; height: 52px; border-radius: 14px; display: flex; align-items: center; justify-content: center; }

  /* ── JOURNEY ── */
  .journey-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(240px,1fr)); gap: 16px; }
  .journey-card {
    background: #111009; border: 1px solid rgba(255,255,255,0.06);
    border-radius: 14px; padding: 24px; border-top: 3px solid #f59e0b;
    transition: transform 0.2s;
  }
  .journey-card:hover { transform: translateY(-3px); }
  .journey-year { font-family: 'Playfair Display', serif; font-size: 36px; font-weight: 900; color: #f59e0b; line-height: 1; margin-bottom: 10px; }
  .journey-title { font-size: 16px; font-weight: 700; color: #fef3e2; margin-bottom: 8px; }
  .journey-text { font-size: 13px; color: #78716c; line-height: 1.6; }

  /* ── SDG ── */
  .sdg-stack { display: flex; flex-direction: column; gap: 12px; }
  .sdg-card {
    background: #111009; border: 1px solid rgba(255,255,255,0.06);
    border-left: 4px solid var(--c); border-radius: 14px; overflow: hidden;
    cursor: pointer; transition: border-color 0.2s;
  }
  .sdg-card:hover { border-left-color: var(--c); }
  .sdg-head { display: flex; align-items: center; gap: 16px; padding: 20px 22px; }
  .sdg-emoji { font-size: 28px; flex-shrink: 0; }
  .sdg-info { flex: 1; }
  .sdg-title { font-size: 17px; font-weight: 700; line-height: 1.3; }
  .sdg-sub { font-size: 13px; color: #78716c; margin-top: 3px; }
  .sdg-chevron { transition: transform 0.3s; flex-shrink: 0; }
  .sdg-chevron.rotated { transform: rotate(180deg); }
  .sdg-body { padding: 0 22px 20px; display: flex; flex-direction: column; gap: 10px; }
  .sdg-point { display: flex; gap: 10px; align-items: flex-start; font-size: 14px; color: #a8a29e; line-height: 1.5; }

  
  /* ── JOIN US ENHANCED ── */
  .jn-hero {
    padding: 110px 40px 80px; text-align: center; position: relative; overflow: hidden;
    background: linear-gradient(135deg,#7c2d12 0%,#9a3412 50%,#7c2d12 100%);
  }
  .jn-hero-deco { position: absolute; color: rgba(255,255,255,0.09); pointer-events: none; }
  .jn-hero-deco-1 { top: 20%; left: 8%; }
  .jn-hero-deco-2 { top: 62%; right: 10%; }
  .jn-hero-deco-3 { bottom: 16%; left: 22%; }
  @media(max-width:768px) { .jn-hero-deco { display: none; } }

  .jn-section-head { text-align: center; margin-bottom: 44px; }
  .jn-section-head .section-label { display: inline-flex; }

  @keyframes jnFadeUp { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: translateY(0); } }

  .jn-cards-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 24px; margin-bottom: 28px; }
  @media(max-width:900px) { .jn-cards-grid { grid-template-columns: 1fr; } }

  .jn-card {
    background: #111009; border: 1px solid rgba(255,255,255,0.07);
    border-radius: 20px; padding: 32px 28px;
    transition: transform 0.25s ease, border-color 0.25s ease;
    animation: jnFadeUp 0.5s ease both;
    animation-delay: calc(var(--i) * 0.08s);
    display: flex; flex-direction: column;
  }
  .jn-card:hover { transform: translateY(-6px); border-color: var(--c); }
  .jn-card-icon-wrap {
    width: 52px; height: 52px; border-radius: 14px;
    display: flex; align-items: center; justify-content: center; margin-bottom: 18px;
  }
  .jn-card-title { font-family: 'Playfair Display', serif; font-size: 22px; font-weight: 800; color: #fef3e2; margin: 0 0 8px; }
  .jn-card-tagline { font-size: 13px; color: #78716c; line-height: 1.6; margin: 0 0 20px; min-height: 40px; }
  .jn-card-fee-row {
    display: flex; align-items: baseline; gap: 6px; margin-bottom: 20px;
    padding-bottom: 20px; border-bottom: 1px solid rgba(255,255,255,0.06);
  }
  .jn-card-fee-num { font-family: 'Playfair Display', serif; font-size: 34px; font-weight: 900; }
  .jn-card-fee-unit { font-size: 13px; color: #78716c; font-weight: 600; }
  .jn-card-benefits { display: flex; flex-direction: column; gap: 10px; margin-bottom: 24px; flex: 1; }
  .jn-card-benefit { display: flex; gap: 8px; align-items: flex-start; font-size: 13px; color: #a8a29e; line-height: 1.5; }
  .jn-card-cta {
    display: flex; align-items: center; justify-content: center; gap: 8px;
    border: none; border-radius: 12px; padding: 13px; color: #0a0908;
    font-weight: 800; font-size: 14px; cursor: pointer; font-family: inherit;
    transition: transform 0.15s, box-shadow 0.15s; width: 100%;
  }
  .jn-card-cta:hover { transform: translateY(-1px); box-shadow: 0 8px 24px -6px rgba(0,0,0,0.4); }
  .jn-card-cta:hover .jn-cta-arrow { transform: translateX(3px); }
  .jn-cta-arrow { transition: transform 0.2s; }

  .jn-notice {
    display: flex; align-items: center; justify-content: center; gap: 8px;
    font-size: 12.5px; color: #a8a29e; background: rgba(245,158,11,0.06);
    border: 1px solid rgba(245,158,11,0.18); border-radius: 50px; padding: 10px 20px;
    max-width: fit-content; margin: 0 auto; text-align: center;
  }

  .jn-why-section { background: #0d0c0a; border-top: 1px solid rgba(255,255,255,0.05); border-bottom: 1px solid rgba(255,255,255,0.05); }
  .jn-why-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px,1fr)); gap: 18px; }
  .jn-why-card { background: #111009; border: 1px solid rgba(255,255,255,0.06); border-radius: 16px; padding: 24px; transition: transform 0.2s, border-color 0.2s; }
  .jn-why-card:hover { transform: translateY(-3px); border-color: rgba(245,158,11,0.25); }
  .jn-why-icon { width: 40px; height: 40px; border-radius: 11px; background: rgba(245,158,11,0.12); display: flex; align-items: center; justify-content: center; margin-bottom: 14px; }
  .jn-why-title { font-size: 15px; font-weight: 700; color: #fef3e2; margin-bottom: 6px; }
  .jn-why-text { font-size: 12.5px; color: #78716c; line-height: 1.6; }

  .jn-steps-row { display: grid; grid-template-columns: repeat(4,1fr); gap: 20px; }
  @media(max-width:900px) { .jn-steps-row { grid-template-columns: 1fr 1fr; } }
  @media(max-width:560px) { .jn-steps-row { grid-template-columns: 1fr; } }
  .jn-step { padding: 24px 20px; background: #111009; border: 1px solid rgba(255,255,255,0.06); border-radius: 14px; }
  .jn-step-num { font-family: 'Playfair Display', serif; font-size: 30px; font-weight: 900; color: rgba(245,158,11,0.35); margin-bottom: 10px; }
  .jn-step-title { font-size: 14px; font-weight: 700; color: #fef3e2; margin-bottom: 6px; }
  .jn-step-text { font-size: 12.5px; color: #78716c; line-height: 1.6; }

  /* ── CONTACT ── */
  .contact-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; }
  .contact-info-col, .social-col { display: flex; flex-direction: column; }
  .office-card {
    background: #111009; border: 1px solid rgba(255,255,255,0.06);
    border-radius: 14px; padding: 20px;
  }
  .office-label { font-size: 11px; font-weight: 800; color: #f59e0b; text-transform: uppercase; letter-spacing: 1.5px; margin-bottom: 10px; }
  .office-address { font-size: 14px; color: #a8a29e; line-height: 1.75; }
  .map-link {
    display: inline-flex; align-items: center; gap: 5px; margin-top: 14px;
    color: #f59e0b; font-size: 13px; font-weight: 700; text-decoration: none;
    border: 1px solid rgba(245,158,11,0.3); border-radius: 8px; padding: 8px 14px;
    transition: all 0.2s;
  }
  .map-link:hover { background: rgba(245,158,11,0.1); }
  .contact-reach { display: flex; flex-direction: column; gap: 8px; margin-top: 20px; }
  .reach-row {
    display: flex; align-items: center; gap: 14px;
    background: #111009; border: 1px solid rgba(255,255,255,0.06);
    border-radius: 12px; padding: 14px 18px; text-decoration: none;
    transition: border-color 0.2s;
  }
  .reach-row:hover { border-color: #f59e0b; }
  .reach-label { font-size: 11px; color: #78716c; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; }
  .reach-val { font-size: 14px; font-weight: 700; color: #fef3e2; margin-top: 3px; }
  .social-cards { display: flex; flex-direction: column; gap: 10px; }
  .social-card {
    display: flex; align-items: center; gap: 14px;
    background: #111009; border: 1px solid rgba(255,255,255,0.06);
    border-radius: 14px; padding: 16px 20px; text-decoration: none;
    transition: border-color 0.2s, transform 0.2s;
  }
  .social-card:hover { border-color: var(--c); transform: translateX(4px); }
  .social-icon { width: 36px; height: 36px; object-fit: contain; border-radius: 8px; }
  .social-name { font-size: 15px; font-weight: 700; color: #fef3e2; }
  .social-handle { font-size: 12px; color: #78716c; margin-top: 2px; }

  /* ── DONATE ── */
  .donate-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px,1fr)); gap: 24px; margin-bottom: 40px; }
  .donate-card {
    background: #111009; border: 1px solid rgba(255,255,255,0.06);
    border-radius: 18px; padding: 28px; display: flex; flex-direction: column;
  }
  .donate-card-label { display: flex; align-items: center; gap: 8px; font-size: 14px; font-weight: 700; color: #fef3e2; margin-bottom: 20px; }
  .upi-qr-wrap { display: flex; justify-content: center; }
  .upi-qr { width: 180px; height: 180px; object-fit: contain; border-radius: 12px; border: 2px solid rgba(255,255,255,0.08); }
  .donate-note { font-size: 13px; color: #78716c; text-align: center; margin-top: 14px; line-height: 1.5; }
  .bank-rows { display: flex; flex-direction: column; flex: 1; }
  .bank-row { display: flex; justify-content: space-between; padding: 10px 0; border-bottom: 1px solid rgba(255,255,255,0.06); }
  .bank-key { font-size: 12px; color: #78716c; font-weight: 600; }
  .bank-val { font-size: 13px; font-weight: 700; color: #fef3e2; text-align: right; max-width: 55%; }
  .donate-online-btn {
    display: inline-flex; align-items: center; gap: 6px; margin-top: 18px;
    background: #3b82f6; color: #fff; text-decoration: none;
    border-radius: 10px; padding: 10px 18px; font-weight: 700; font-size: 13px;
    transition: opacity 0.2s;
  }
  .donate-online-btn:hover { opacity: 0.85; }
  .tax-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px,1fr)); gap: 20px; margin-bottom: 48px; }
  .tax-card { background: #111009; border: 1px solid rgba(255,255,255,0.06); border-radius: 14px; padding: 24px; }
  .tax-row { display: flex; gap: 10px; align-items: center; margin-bottom: 10px; font-size: 14px; color: #a8a29e; }
  .items-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px,1fr)); gap: 16px; margin-bottom: 40px; }
  .item-card {
    background: #111009; border: 1px solid rgba(255,255,255,0.06);
    border-top: 3px solid var(--c); border-radius: 14px; padding: 20px;
    transition: transform 0.2s;
  }
  .item-card:hover { transform: translateY(-3px); }
  .item-icon-wrap { width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center; margin-bottom: 12px; }
  .item-title { font-size: 16px; font-weight: 800; margin-bottom: 10px; }
  .item-bullet { font-size: 12px; color: #78716c; line-height: 2; }
  .emergency-card {
    display: flex; align-items: center; gap: 18px; flex-wrap: wrap;
    background: rgba(239,68,68,0.06); border: 1px solid rgba(239,68,68,0.2);
    border-radius: 16px; padding: 24px 28px; margin-bottom: 16px;
  }
  .emergency-title { font-size: 16px; font-weight: 800; color: #ef4444; }
  .emergency-sub { font-size: 13px; color: #78716c; margin-top: 3px; }
  .emergency-call {
    margin-left: auto; background: #ef4444; color: #fff; text-decoration: none;
    border-radius: 10px; padding: 10px 20px; font-weight: 800; font-size: 14px;
    transition: opacity 0.2s;
  }
  .emergency-call:hover { opacity: 0.85; }

  /* ── CERTS ── */
  .certs-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px,1fr)); gap: 18px; margin: 40px 0 60px; }
  .cert-card {
    background: #111009; border: 1px solid rgba(255,255,255,0.06);
    border-radius: 14px; overflow: hidden; cursor: pointer;
    transition: transform 0.2s, border-color 0.2s;
  }
  .cert-card:hover { transform: translateY(-4px); border-color: rgba(167,139,250,0.4); }
  .cert-img-wrap { position: relative; padding-top: 72%; background: #1a1714; }
  .cert-img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
  .cert-overlay {
    position: absolute; inset: 0;
    background: rgba(0,0,0,0); display: flex; align-items: center; justify-content: center;
    transition: background 0.2s;
  }
  .cert-card:hover .cert-overlay { background: rgba(0,0,0,0.4); }
  .cert-num {
    position: absolute; top: 8px; right: 8px;
    background: rgba(0,0,0,0.7); color: rgba(255,255,255,0.7);
    font-size: 10px; font-weight: 700; padding: 3px 8px; border-radius: 6px;
  }
  .cert-info { padding: 14px 16px 18px; }
  .cert-title { font-size: 13px; font-weight: 700; color: #a78bfa; margin-bottom: 5px; line-height: 1.4; }
  .cert-by { font-size: 11px; color: #78716c; margin-bottom: 3px; }
  .cert-year { font-size: 11px; color: #52504d; }

  /* ── GALLERY ── */
  .gallery-hero {
    padding: 40px 24px; display: flex; align-items: center; gap: 20px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }
  .gallery-hero-emoji { font-size: 52px; }
  .gallery-hero-title { font-family: 'Playfair Display', serif; font-size: 32px; font-weight: 800; color: #fef3e2; }
  .gallery-hero-count { font-size: 14px; color: #78716c; margin-top: 4px; }
  .cat-bar {
    display: flex; gap: 8px; padding: 14px 20px; overflow-x: auto;
    background: #0a0908; border-bottom: 1px solid rgba(255,255,255,0.05);
    scrollbar-width: none;
  }
  .cat-bar::-webkit-scrollbar { display: none; }
  .cat-pill {
    background: #1a1714; border: 1px solid rgba(255,255,255,0.08);
    color: #a8a29e; border-radius: 50px; padding: 8px 18px;
    font-size: 13px; font-weight: 700; cursor: pointer;
    white-space: nowrap; transition: all 0.2s; font-family: 'Plus Jakarta Sans', sans-serif;
  }
  .cat-pill:hover { border-color: rgba(255,255,255,0.2); color: #fef3e2; }
  .gallery-grid {
    display: grid; grid-template-columns: repeat(auto-fill, minmax(160px,1fr));
    gap: 8px; padding: 16px;
  }
  .gallery-item {
    aspect-ratio: 3/4; border-radius: 12px; overflow: hidden;
    cursor: pointer; position: relative;
    background: #1a1714;
  }
  .gallery-img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.3s; }
  .gallery-item:hover .gallery-img { transform: scale(1.06); }
  .gallery-overlay {
    position: absolute; inset: 0;
    background: rgba(0,0,0,0); display: flex; align-items: center; justify-content: center;
    transition: background 0.25s;
  }
  .gallery-item:hover .gallery-overlay { background: rgba(0,0,0,0.35); }
  .gallery-num {
    position: absolute; bottom: 6px; right: 8px;
    font-size: 10px; font-weight: 700; color: rgba(255,255,255,0.6);
    background: rgba(0,0,0,0.4); padding: 2px 7px; border-radius: 6px;
  }
  .load-more-btn {
    background: #111009; border: 1px solid rgba(255,255,255,0.12);
    color: #fef3e2; border-radius: 50px; padding: 14px 32px;
    font-size: 14px; font-weight: 700; cursor: pointer; transition: all 0.2s;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }
  .load-more-btn:hover { background: #f59e0b; color: #0a0908; border-color: #f59e0b; }

  /* ── LIGHTBOX ── */
  .lightbox {
    position: fixed; inset: 0; background: rgba(0,0,0,0.95);
    z-index: 9999; display: flex; align-items: center; justify-content: center;
    backdrop-filter: blur(12px); cursor: pointer;
  }
  .lightbox-inner { display: flex; flex-direction: column; align-items: center; position: relative; }
  .lb-close {
    position: absolute; top: -44px; right: -4px;
    background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.15);
    color: #fff; border-radius: 50%; width: 36px; height: 36px;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: background 0.2s;
  }
  .lb-close:hover { background: rgba(255,255,255,0.2); }
  .lb-img { max-width: 90vw; max-height: 80vh; object-fit: contain; border-radius: 10px; }
  .lb-caption { margin-top: 16px; text-align: center; }
  .lb-cap-title { font-size: 17px; font-weight: 700; color: #fef3e2; }
  .lb-cap-sub { font-size: 13px; color: #78716c; margin-top: 4px; }

  /* ── FOOTER ── */
  .site-footer {
    background: #060504; border-top: 1px solid rgba(255,255,255,0.05);
    padding: 40px 24px 32px;
  }
  .footer-inner { max-width: 1280px; margin: 0 auto; display: flex; align-items: center; gap: 32px; flex-wrap: wrap; justify-content: space-between; }
  .footer-brand { display: flex; align-items: center; gap: 14px; }
  .footer-logo { width: 44px; height: 44px; object-fit: contain; border-radius: 10px; }
  .footer-brand-name { font-family: 'Playfair Display', serif; font-size: 17px; font-weight: 800; color: #fef3e2; }
  .footer-tagline { font-size: 11px; color: #52504d; margin-top: 3px; font-weight: 600; text-transform: uppercase; letter-spacing: 1px; }
  .footer-meta { flex: 1; min-width: 200px; }
  .footer-reg { font-size: 12px; color: #52504d; line-height: 1.8; }

  /* ── RESPONSIVE ── */
  @media (max-width: 900px) {
    .vm-grid { grid-template-columns: 1fr; }
    .contact-grid { grid-template-columns: 1fr; }
    .section-header-row { flex-direction: column; align-items: flex-start; }
    .section-tagline { text-align: left; max-width: 100%; }
  }
  @media (max-width: 768px) {
    .nav-links { display: none; }
    .hamburger { display: flex; }
    .nav-donate-btn { display: none; }
    .hero-content { padding: 32px 20px 28px; }
    .hero-btns { flex-direction: column; }
    .hero-micro-stats { gap: 18px; }
    .stats-band { padding: 20px 16px; gap: 8px; }
    .stat-pill { min-width: 0; flex: 1 1 calc(50% - 8px); }
    .cta-inner { flex-direction: column; text-align: center; }
    .cta-actions { justify-content: center; }
    .page-hero { padding: 72px 24px 52px; }
    .gallery-grid { grid-template-columns: repeat(auto-fill, minmax(120px,1fr)); gap: 6px; }
    .footer-inner { flex-direction: column; align-items: flex-start; gap: 20px; }
    .emergency-call { margin-left: 0; }
        .jn-hero { padding: 72px 20px 52px; }
    .jn-card { padding: 26px 22px; }
    .jn-notice { max-width: 100%; }
  }
  @media (max-width: 480px) {
    .stat-pill { flex: 1 1 100%; }
    .hero-title { font-size: 42px; }
        .jn-card-fee-num { font-size: 28px; }
  }
`;